import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import {
    COMN_BASE,
    COMN_URLS,
    COMN_APIS,
    SF_APP_DTL_BILL_INFO,
} from "@/tz/go/egaz/osci/lpco/comn/services/OsciLpcoComnAppService";

export const APP_DTL_BILL_INFO = (props: any) => {
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    const params = { ...props.state };

    const form = {
        appDtlBillInfo: useForm({
            defaultSchema: SF_APP_DTL_BILL_INFO,
        }),
    };

    /*
     * Application Item Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getAppFeePayInfo: useFetch({
            api: () => {
                return COMN_APIS.getAppFeePayInfo({ ...params });
            },
            onSuccess: (data) => {
                if (data.feePayInfo.content!) {
                    form.appDtlBillInfo.setValues(data.feePayInfo.content);
                }
            },
            onError: (error) => {
                const errmsg = error.response.data.errorCode == -1 ? "msg.osc.00015" : error.response.data.errorMessage;

                modal.openModal({
                    content: errmsg,
                });
            },
            showToast: false,
        }),
    };

    /*
     * Application Item Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        setInit: () => {
            fetch.getAppFeePayInfo.fetch();
        },
    };

    useEffect(() => {
        handler.setInit();
    }, []);

    return (
        <Page>
            {/* <form> */}
            <Group>
                <Group.Body>
                    <Layout direction="col">
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"T_BLL_DTL_1"} titleSize={1}></Group.Title>
                            </Layout.Left>
                        </Layout>

                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.appDtlBillInfo.schema.bllNo} />
                                <Group.Control {...form.appDtlBillInfo.schema.feePrcssStatNm} />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.appDtlBillInfo.schema.bllIssDt} />
                                <Group.Control {...form.appDtlBillInfo.schema.bllXpirDt} />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.appDtlBillInfo.schema.feeImpsTpNm} />
                                <Group.Control {...form.appDtlBillInfo.schema.bllAmt} />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.appDtlBillInfo.schema.payMetdNm} />
                                <Group.Control {...form.appDtlBillInfo.schema.payAmt} />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.appDtlBillInfo.schema.feePayDtm} controlSize={10} />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.appDtlBillInfo.schema.rmrk} controlSize={10} />
                            </Group.Row>
                        </Group.Section>
                    </Layout>
                </Group.Body>
            </Group>
        </Page>
    );
};
